import api from "@/api.js";
import actions from "./actions";

export default {
  namespaced: true,
  modules: {
    actions,
  },
  state: {
    list: [],
    listLoading: false,
    selectedSolution: null,
    listSaved: [],
    listSavedLoading: false,
    listRecentSelected: [],
    listRecentSelectedLoading: false,

  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setListSaved(state, payload) {
      state.listSaved = payload;
    },
    setListSavedLoading(state, payload) {
      state.listSavedLoading = payload;
    },
    setSelectedSolution(state, payload) {
      state.selectedSolution = payload;
    },
    setListRecentSelected(state, payload) {
      state.listRecentSelected = payload;
    },
    setListRecentSelectedLoading(state, payload) {
      state.listRecentSelectedLoading = payload;
    },
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("solutions/business");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadAllSaved({ commit }) {
      commit("setListSavedLoading", true);
      let list = await api.get("solutions/business/saved");
      commit("setListSaved", list.data);
      commit("setListSavedLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("solutions/business/byID", {
        params: { id: id },
      });
      commit("setSelectedSolution", list.data[0]);
      commit("setListLoading", false);
    },
    async loadBySourceID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("solutions/business/bySourceID", {
        params: { id: id },
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadBySolutionsID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("solutions/business/bySolutionsID", {
        params: { id: id },
      });
      commit("setSelectedSolution", list.data[0]);
      commit("setListLoading", false);
    },
    async newMass({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("solutions/business/massCreate", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      return returnData;
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("solutions/business", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`solutions/business`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async removeSolution({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("solutions/business/remove", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async loadRecentSelected({ commit }) {
      commit("setListRecentSelectedLoading", true);
      let list = await api.get("solutions/business/recentSelected");
      commit("setListRecentSelected", list.data);
      commit("setListRecentSelectedLoading", false);
    }
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    listSaved(state) {
      return state.listSaved;
    },
    listSavedLoading(state) {
      return state.listSavedLoading;
    },
    listAdopted(state) {
      return state.list
        .filter((s) => {
          return s.solutionsBusiness_id;
        })
        .sort((a, b) => 0.5 - Math.random());
    },
    selectedSolution(state) {
      return state.selectedSolution;
    },
    listRecentSelected(state) {
      return state.listRecentSelected
    },
    listRecentSelectedLoading(state) {
      return state.listRecentSelectedLoading
    },
  },
};
